// @ts-ignore
import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
    url: "https://auth.screensights.io",
    realm: "screen-sights-dashboard",
    clientId: "dashboard",
});

export default keycloak;